module.exports = __webpack_public_path__ + "img/wazdan.449d3634.jpg";